import { Component, input, output } from '@angular/core';
import { GewerkDto } from '../../../core/models/gewerk.model';
import { GewerkIconComponent } from '../gewerk-icon/gewerk-icon.component';

@Component({
  selector: 'app-kategorie-grid',
  standalone: true,
  imports: [GewerkIconComponent],
  templateUrl: './kategorie-grid.component.html',
  styleUrl: './kategorie-grid.component.scss',
})
export class KategorieGridComponent {
  readonly gewerke = input.required<GewerkDto[]>();
  readonly kategorieSelected = output<GewerkDto>();
  /** "Alle Gewerke →"-Kachel — füllt das 4×3-Raster und führt zur Suche. */
  readonly alleSelected = output<void>();
}
